import type { FirebaseClient, FirebaseClientConfig } from '@akpl/firebase/client';

let client: FirebaseClient | null = null;

/**
 * The browser as the screen signs in on its own named app, because `signInWithCustomToken` on the
 * default one would replace the signed-in user (docs/13 §2). `memory` persistence: the host token
 * is never stored. The SDK chunk is fetched when a session starts, not for visiting the Home.
 */
export async function signInHost(
  config: FirebaseClientConfig,
  customToken: string,
): Promise<FirebaseClient> {
  if (!client) {
    const { initFirebase } = await import('@akpl/firebase/client');
    client = initFirebase(config, { appName: 'akp-host', persistence: 'memory' });
  }
  await client.signInWithCustomToken(customToken);
  return client;
}

/** §5.9: "Cerrar sesión" closes the `akp-host` instance too. */
export async function signOutHost(): Promise<void> {
  await client?.signOut();
}
